import React from 'react'
import { PickerFile } from '../useGooglePicker'

type Props = {
  files: PickerFile[]
  onRemove: (id: string) => void
}

export function PickerSelectedImages({ files, onRemove }: Props) {
  if (files.length === 0) return null

  return (
    <div className="flex flex-wrap gap-2 mt-2">
      {files.map(file => (
        <div key={file.id} className="relative group w-16 h-16 flex-shrink-0">
          {file.thumbnailUrl ? (
            <img
              src={file.thumbnailUrl}
              alt={file.name}
              className="w-full h-full object-cover rounded-lg border border-gray-200"
            />
          ) : (
            <div className="w-full h-full rounded-lg border border-gray-200 bg-gray-100 flex items-center justify-center">
              <i className="fa fa-image text-gray-300 text-xl" />
            </div>
          )}
          <button
            type="button"
            onClick={() => onRemove(file.id)}
            className="absolute -top-1.5 -right-1.5 w-5 h-5 rounded-full bg-gray-700 text-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity shadow"
          >
            <i className="fa fa-times text-[10px]" />
          </button>
          <div className="absolute inset-x-0 bottom-0 rounded-b-lg bg-black/50 px-1 py-0.5 opacity-0 group-hover:opacity-100 transition-opacity">
            <p className="text-white text-[9px] truncate">{file.name}</p>
          </div>
        </div>
      ))}
    </div>
  )
}
